import React from 'react'
import { Button, Col, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import CustomerObj from '../../../features/customer/customerObj';
import { useSelector } from 'react-redux';
import { selectCustomer } from '../../../features/customer/customerSlice';
import { mightyPointsToCurrency } from '../../../features/customer/mightyPointsUtils';

export const YourBenefits = () => {
    const customer = new CustomerObj(useSelector(selectCustomer));
    const mightyPoints = customer ? customer.getMightyPoints() : 0;

    return (
        <div className='pt-2 px-2'>
            <div className='fw-500 fs-32px font-poppins mt-2 pt-2 text-center text-uppercase'>YOUR BENEFITS</div>
            <Row className='my-2 px-2 d-flex justify-content-center'>
                <Col xs={12} xl={4} md={6} className='p-2'>
                    <div className='border border-2 h-100 d-flex justify-content-center align-items-center flex-column p-5 pb-2'>
                        <h2 className='font-league-gothic fw-400 fs-40px pb-2'>FREE Nutrition Advice!</h2>
                        <div className='font-barlow fw-400 text-center fs-18px lh-24px pb-3'>
                            Kickstart your journey to a healthier you by booking a FREE consultation with one of our Nutrition Team’s expert Registered Dietitians.
                        </div>
                        <div className='text-center my-3'>
                            <Button
                                variant="success"
                                size="sm"
                                as={Link as any}
                                target='_blank'
                                className='text-uppercase font-barlow fw-500 fs-16px'
                                to={`https://mightymeals.as.me/`}
                            >
                                Book Now
                            </Button>
                        </div>
                    </div>
                </Col>
                <Col xs={12} xl={4} md={6} className='p-2'>
                    <div className='bg-success p-4 pb-2 h-100 d-flex justify-content-center align-items-center flex-column'>
                        <h2 className='text-white fw-400 fs-40px font-league-gothic mb-0'>REFER A FRIEND</h2>
                        <h3 className='text-white font-barlow fw-500 fs-32px pb-3'>GIVE $100 | GET $50</h3>
                        <p className='text-white text-center fs-18px fw-400 font-barlow lh-24px pb-3'>Give friends
                            <span className='fw-bold'> $100</span> off
                            their first four orders and you'll
                            get <span className='fw-bold'>$50</span> worth of Mighty
                            Points when they purchase.</p>
                        <div>
                            <Button
                                variant="light"
                                size="sm"
                                as={Link as any}
                                className='text-uppercase font-barlow fw-500 fs-16px'
                                to={`/my-account/refer-a-friend`}
                            >
                                Start Sharing
                            </Button>
                        </div>
                    </div>
                </Col>
                <Col xs={12} xl={4} md={6} className='p-2'>
                    <div className='mightypoints-summary bg-primary-300 h-100 d-flex justify-content-center align-items-center flex-column p-4 pb-2'>
                        <div className={`fw-500 text-white font-barlow fs-20px text-center text-uppercase`}>
                            You have earned
                        </div>
                        <div className={`fw-500 text-success text-center font-barlow fs-65px`}>
                            {mightyPointsToCurrency(mightyPoints, true)}
                        </div>
                        <div className='text-white font-barlow fw-500 fs-30px text-center text-uppercase pb-3'>
                            In Mighty Points!
                        </div>
                        <div className='text-center my-3'>
                            <Button
                                variant="success"
                                size="sm"
                                as={Link as any}
                                className='text-uppercase'
                                to={`/my-account/mightypoints`}
                            >
                                View Points
                            </Button>
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    )
}